export default __webpack_public_path__ + "static/media/result3.f146dcef.png";